import {Component, ElementRef, inject, Signal, viewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';
import {Store} from '@ngrx/store';
import {MatSnackBar} from '@angular/material/snack-bar';

import {selectTerritories} from '../../../../../../state/location/location.reducer';
import {Territory} from '../../../../../../core/classes/territory';

@Component({
  selector: 'tgrid-base-state-report-widget',
  template: '',
  standalone: true,
})
export abstract class BaseStateReportWidget {
  protected activatedRoute = inject(ActivatedRoute);
  protected snackBar = inject(MatSnackBar);

  protected exportContent: Signal<ElementRef | undefined> = viewChild('exportContent', {read: ElementRef});
  protected legendContent: Signal<ElementRef | undefined> = viewChild('legendContent', {read: ElementRef});

  public territories: Signal<Territory[]> = toSignal(inject(Store).select(selectTerritories),
    {initialValue: []},
  );


  protected stateParam: Signal<string> = toSignal(this.activatedRoute.params.pipe(map(params => params['stateAbbr'])));
  protected yearParam: Signal<number> = toSignal(this.activatedRoute.params.pipe(map(params => params['year'])));


  protected abstract export(): void | Promise<void>;

}
